<script>
  export let data;
  export let isMobile;
  export let index;

  import { fade } from "svelte/transition";
  import { onMount } from "svelte";
  import { createEventDispatcher } from "svelte";
  import ContentTileComponent from "./ContentTileComponent.svelte";

  let isVisible = false;
  let dispatch = createEventDispatcher();
  let pageId = null;

  function handleClick(pageId) {
    dispatch("changepage", {
      pageId: pageId
    });
  }

  onMount(() => {
    isVisible = true;
  });
</script>

<style>
  .page-component {
    display: block;
    position: absolute;
    height: 100vh;
    width: 89.3%;
    left: 0;
    will-change: transform;
  }

  .page-component.is-mobile-true {
    width: 100%;
    -webkit-overflow-scrolling: touch;
    border-right: none;
    word-break: break-word;
  }

  h1 {
    font-size: 13vw;
    line-height: 0.9;
    margin: 0 0 5vw 0;
    width: 75%;
  }

  h2 {
    margin: 0;
    font-size: 28px;
    line-height: 1;
  }

  h3 {
    font-size: 3vw;
    line-height: 1;
    margin: 0 0 5vw 0;
    width: 50%;
  }

  a {
    font-family: adieuRegular;
    font-weight: normal;
    font-size: 20px;
    text-transform: uppercase;
  }

  .green {
    background: #bbf0a8;
  }

  .purple {
    background: #C9AEE8;
  }

  .blue {
    background: #c9e7ed;
  }

  .yellow {
    background: #fff576;
  }

  .orange {
    background: #e4b7a6;
  }

  .new-green {
    background: #8AF364;
    color: black;
  }

  .new-pink {
    background: #FFC0CB;
    color: black;
  }

  .new-red {
    background: #F84F32;
    color: black;
  }

  .new-blue {
    background: blue;
    color: white;
  }

  .new-yellow {
    background: yellow;
    color: black;
  }

  .page-component-nav-wrapper {
    position: absolute;
    right: 2px;
    top: 2px;
    height: 100%;
    padding-right: 4px;
    cursor: pointer;
  }

  .page-component-nav-wrapper:hover {
    font-style: italic;
  }

  .page-component-nav-item {
    position: absolute;
    top: 4px;
    left: 0;
    background: none;
    transform-origin: 0 0;
    transform: rotate(90deg);
    white-space: nowrap;
  }

  .page-component-layout-wrapper {
    padding: 6%;
    max-width: 1600px;
  }

  .page-component-content-wrapper {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    width: 100%;
    margin-bottom: 10%;
  }
  .page-component-header {
    padding-left: 8px;
  }

  .page-component-header h1 {
    width: 50%;
  }

  @media (max-width: 700px) {
    .page-component-header {
      padding-left: 0;
    }
    .page-component-layout-wrapper {
      padding-top: 1%;
      padding-bottom: 20%;
    }
    .page-component-content-wrapper {
      padding: 0 0 40px 0;
    }
    h1 {
      font-size: 24px;
      margin-bottom: 6%;
      white-space: nowrap;
    }
    h3 {
      font-size: 44px;
      width: 100%;
      margin-bottom: 8vw;
    }
  }
</style>

<div
  class="page-component {data.content.colorScheme} is-mobile-{isMobile}"
  id={data.id}
  on:click={() => {
    handleClick(data.id);
  }}>
  {#if !isMobile}
    <div class="page-component-nav-wrapper">
      <h2 class="page-component-nav-item">{data.name}</h2>
    </div>
  {/if}
  {#if isVisible}
    <div
      class="page-component-layout-wrapper"
      transition:fade={{ delay: 0, duration: 1200 }}>
      <div class="page-component-header">
        <h1>{data.content.headline}</h1>
        <h3>{data.content.subHeadline}</h3>
      </div>
      <div class="page-component-content-wrapper">
        {#each data.content.contentTiles as tile}
          <ContentTileComponent {tile} />
        {/each}
      </div>
    </div>
  {/if}
</div>
